import { Injectable, signal } from '@angular/core';
import { POMailingAddressVO } from '../models/po-mailing-address.vo';

@Injectable({
  providedIn: 'root'
})
export class PoMailingAddressService {

  private ieee_storageKey = 'ieee_poMailingAddress';
  private asme_storageKey = 'asme_poMailingAddress';

  private _ieeeData = signal<POMailingAddressVO | null>(null);
  private _asmeData = signal<POMailingAddressVO | null>(null);

  ieeeData = this._ieeeData.asReadonly();
  asmeData = this._asmeData.asReadonly();

  constructor() {

    const ieeeStored = localStorage.getItem(this.ieee_storageKey);

    if (ieeeStored) {
      try {
        this._ieeeData.set(JSON.parse(ieeeStored));
      } catch {
        localStorage.removeItem(this.ieee_storageKey);
      }
    }

    const asmeStored = localStorage.getItem(this.asme_storageKey);

    if (asmeStored) {
      try {
        this._asmeData.set(JSON.parse(asmeStored));
      } catch {
        localStorage.removeItem(this.asme_storageKey);
      }
    }
  }

  // IEEE

  setIeeeData(value: POMailingAddressVO): void {
    localStorage.setItem(this.ieee_storageKey, JSON.stringify(value));
    this._ieeeData.set(value);
  }

  getIeeeData(): POMailingAddressVO | null {
    return this._ieeeData();
  }

  // ASME

  setAsmeData(value: POMailingAddressVO): void {
    localStorage.setItem(this.asme_storageKey, JSON.stringify(value));
    this._asmeData.set(value);
  }

  getAsmeData(): POMailingAddressVO | null {
    return this._asmeData();
  }

  clear(): void {
    localStorage.removeItem(this.ieee_storageKey);
    localStorage.removeItem(this.asme_storageKey);

    this._ieeeData.set(null);
    this._asmeData.set(null);
  }
}